export const languageEnum = (languageCode: string): string => {
  switch (languageCode) {
    case 'en':
      return 'english';
    case 'fr':
      return 'french';
    case 'ar':
      return 'arabic';

    default:
      throw new Error('Implement the missing enum');
  }
};
